import React from 'react'

import { Icon } from '@components/shared/elements'

class Loading extends React.Component {

  // constructor(props, context) {
  //   super(props);

  //   this.state = { frame: 1 };
  // }

  // componentDidMount() {
  //   // if has error retry to load the component
  //   if(this.props.error) {
  //     this.props.retry();
  //   }
  //   this.interval = setInterval(() => {
  //     this.setState({
  //       frame: this.state.frame + 1
  //     });
  //   }, this.props.interval);
  // }

  // componentWillUnmount() {
  //   clearInterval(this.interval);
  // }

  render() {

    if (this.props.error) {
      return (
        <div>
          <div className='grid-container'>
            <p className='mt6'><strong>Ops!</strong></p>
            <p>Desculpe, ocorreu um erro e a página que você estava acessando não foi carregada.</p>
            <button className='button hollow small' onClick={ this.props.retry }>Recarregar</button>
            <p className='mb8'>Se a página não carregar, verifique sua conexão.</p>
          </div>
        </div>
      )
    } else {

      // let dots = this.state.frame % (this.props.dots + 1);
      // let text = '.';

      // while (dots > 0) {
      //   text += '.';
      //   dots--;
      // }

      return (
        <div>
          <div className='loader'><Icon icon='spinner' size='2x' spin /></div>
          {/* <p className='mt4 mb8'><small>{text}</small></p> */}
        </div>
      )
    }
  }
}

// Loading.defaultProps = {
//   interval: 300,
//   dots: 3
// };


export default Loading



// WEBPACK FOOTER //
// ./src/components/shared/elements/Loading.js